export function parseUrl(url?: string) {
	if (url && !/^https?:\/\//i.test(url)) {
		return `http://${url}`;
	}
	return url;
}
